<div id="debugger-menu-container">
  <button id="debugger-control-button" *ngIf="!debuggerToggle" mat-fab (click)="onDebuggerToggle()">
    <mat-icon>bug_report</mat-icon>
  </button>
</div>

<div id="debugger-window" *ngIf="debuggerToggle"
     [class.debugger-window-full]="windowPin==='full'"
     [class.debugger-window-top]="windowPin==='top'"
     [class.debugger-window-bottom]="windowPin==='bottom'"
     [class.debugger-window-left]="windowPin==='left'"
     [class.debugger-window-right]="windowPin==='right'"
>

  <mat-toolbar id="debugger-toolbar">

    <button mat-icon-button>
      <mat-icon>article</mat-icon>
    </button>

    <button mat-icon-button>
      <mat-icon>memory</mat-icon>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="lockMenu">
      <mat-icon>window</mat-icon>
    </button>

    <button mat-icon-button (click)="toggleAutoscroll()" [color]="autoscroll ? 'accent' : ''" matTooltip="Toggle Autoscroll">
      <mat-icon>vertical_align_bottom</mat-icon>
    </button>

    <mat-menu #lockMenu="matMenu">
      <button mat-menu-item (click)="pinWindow('full')">
        <mat-icon>fit_screen</mat-icon>
        <span>Fullscreen</span>
      </button>
      <button mat-menu-item (click)="pinWindow('top')">
        <mat-icon>keyboard_arrow_up</mat-icon>
        <span>Top</span>
      </button>
      <button mat-menu-item (click)="pinWindow('bottom')">
        <mat-icon>keyboard_arrow_down</mat-icon>
        <span>Bottom</span>
      </button>
      <button mat-menu-item (click)="pinWindow('left')">
        <mat-icon>keyboard_arrow_left</mat-icon>
        <span>Left</span>
      </button>
      <button mat-menu-item (click)="pinWindow('right')">
        <mat-icon>keyboard_arrow_right</mat-icon>
        <span>Right</span>
      </button>
    </mat-menu>

    <span class="toolbar-fill-remaining-space"></span>

    <button mat-icon-button (click)="onDebuggerToggle()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <div id="debugger-content" #logContainer>
    <div class="log-entry" *ngFor="let log of logs" [ngClass]="'log-' + log.type">
      <span class="log-timestamp">{{ log.timestamp | date:'HH:mm:ss' }}</span>
      <span class="log-type">[{{ log.type }}]</span>
      <span class="log-message">
        <ng-container *ngFor="let msg of log.message">
          <pre>{{ msg | json }}</pre>
        </ng-container>
      </span>
    </div>
  </div>

</div>
